import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { FindHostelPage } from './pages/FindHostelPage';
import { HostelDetailPage } from './pages/HostelDetailPage';
import { RoommateMatchPage } from './pages/RoommateMatchPage';
import { MarketplacePage } from './pages/MarketplacePage';
import { AmbassadorsPage } from './pages/AmbassadorsPage';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { StudentDashboard } from './pages/StudentDashboard';
import { LandlordDashboard } from './pages/LandlordDashboard';
import { UniversityDashboard } from './pages/UniversityDashboard';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/find-hostel" element={<FindHostelPage data-id="element-5" />} data-id="element-4" />
        <Route path="/hostel/:id" element={<HostelDetailPage data-id="element-7" />} data-id="element-6" />
        <Route path="/roommate-match" element={<RoommateMatchPage data-id="element-9" />} data-id="element-8" />
        <Route path="/marketplace" element={<MarketplacePage data-id="element-11" />} data-id="element-10" />
        <Route path="/ambassadors" element={<AmbassadorsPage data-id="element-13" />} data-id="element-12" />
        <Route path="/login" element={<LoginPage data-id="element-15" />} data-id="element-14" />
        <Route path="/signup" element={<SignupPage data-id="element-17" />} data-id="element-16" />

        {/* Dashboards */}
        <Route path="/dashboard/student/*" element={<StudentDashboard data-id="element-19" />} data-id="element-18" />
        <Route path="/dashboard/landlord/*" element={<LandlordDashboard data-id="element-21" />} data-id="element-20" />
        <Route path="/dashboard/university/*" element={<UniversityDashboard data-id="element-23" />} data-id="element-22" />
      </Routes>
    </BrowserRouter>;
}